import React from 'react';
import t from 'react-translate';
import { IntegrationType } from 'redux/schemas/models/mentoring-program-sessions';

import { css } from '@emotion/react';
import { msTeamsColor, zoomColor } from 'athena/styles/colors';

import { Button } from 'react-bootstrap';
import NvIcon from 'shared/components/nv-icon';
import { SessionTypes } from 'redux/schemas/models/live-event';
import { semiBoldFontWeight } from 'styles/global_defaults/fonts';

const integrationSettings = {
  [SessionTypes.MS_TEAMS]: {
    color: msTeamsColor,
    label: 'JOIN_MS_TEAMS_MEETING',
  },
  [SessionTypes.ZOOM]: {
    color: zoomColor,
    label: 'JOIN_ZOOM_MEETING',
  },
};

type MeetingLinkViewModeProps = {
  link?: string;
  sessionType?: SessionTypes;
};

const MeetingLinkViewMode = React.memo(({ link, sessionType }: MeetingLinkViewModeProps) => {
  const { color, label } = integrationSettings[sessionType];
  const styles = css`
    .meeting-link-text {
      color: ${color};
      font-weight: ${semiBoldFontWeight} !important;
    }
  `;

  return (
    <div css={styles} className='d-flex meeting-link pb-1 align-items-center'>
      <NvIcon
        icon='zoom'
        size='smallest'
        className='pr-2'
      />
      <Button
        href={link}
        target='_blank'
        variant='link'
        className='heading-5 meeting-link-text p-0'
      >
        {t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.MEETING_LINK[label]()}
      </Button>
    </div>
  );
});

export default MeetingLinkViewMode;
